import { useState } from "react";
import Container from "../../components/container/Container";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
} from "firebase/auth";
import { auth, database, provider } from "../../database/firebase";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import { setDoc, doc } from "firebase/firestore";

const SignUp = () => {
  // const history = useHistory();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const signUpWithEmailAndPassword = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await createUserWithEmailAndPassword(auth, email, password).then(
        async (user) => {
          await updateProfile(auth.currentUser, {
            displayName: `${firstName} ${lastName}`,
          });
          await setDoc(doc(database, "users", user.user.uid), {
            name: user.user.displayName
              ? user.user.displayName
              : `${firstName} ${lastName}`,
            email: user.user.email,
            uid: user.user.uid,
            userImage: user.user.photoURL,
          });
        }
      );
      setLoading(false);
    } catch (error) {
      alert(error.message);
    }
  };

  const signUpwithGoogle = async () => {
    try {
      setGoogleLoading(true);
      await signInWithPopup(auth, provider).then(async (user) => {
        await setDoc(doc(database, "users", user.user.uid), {
          name: user.user.displayName
            ? user.user.displayName
            : `${firstName} ${lastName}`,
          email: user.user.email,
          uid: user.user.uid,
          userImage: user.user.photoURL,
        });
      });
      setGoogleLoading(false);
    } catch (error) {
      alert(error.message);
      setGoogleLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Container>
        <div className="py-3 px-3 lg:px-0">
          <Link to="/">
            <img
              src="/images/LogoSec.png"
              alt="Logo"
              className="cursor-pointer h-10"
            />
          </Link>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-10 lg:items-center">
          <div className="flex flex-col space-y-8 px-3 lg:px-20 py-3 ">
            <div className="flex justify-center lg:justify-end">
              <h1 className="font-bold text-3xl text-indigo-500 font-serif">
                Sign Up
              </h1>
            </div>
            <div className="space-y-3 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-5">
              <div
                onClick={signUpwithGoogle}
                className="flex cursor-pointer items-center border border-indigo-400 bg-indigo-500"
              >
                <div className="bg-white px-3 py-2">
                  <img src="/images/google.png" alt="google" className="h-6" />
                </div>
                <div className="ml-10 lg:ml-3">
                  <p className="font-semibold font-serif text-white">
                    {googleLoading ? (
                      <ClipLoader
                        color="white"
                        loading={googleLoading}
                        size={25}
                      />
                    ) : (
                      "Signup with Google"
                    )}
                  </p>
                </div>
              </div>
              <div className="flex items-center border cursor-pointer border-indigo-400 bg-indigo-500">
                <div className="bg-white px-3 py-2">
                  <img src="/images/github.png" alt="google" className="h-6" />
                </div>
                <div className="ml-10 lg:ml-3">
                  <p className="font-semibold font-serif text-white">
                    Signup with Github
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <p className="font-bold text-lg">or</p>
            </div>
            <div className="">
              <form
                className="flex flex-col space-y-5"
                onSubmit={signUpWithEmailAndPassword}
              >
                <div className="grid grid-cols-2 gap-3">
                  <input
                    className="signup__input"
                    type="text"
                    placeholder="First Name"
                    required
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <input
                    className="signup__input"
                    type="text"
                    placeholder="Last Name"
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
                <div className="flex flex-col space-y-5">
                  <input
                    className="signup__input"
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    className="signup__input"
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="">
                  <button
                    type="submit"
                    className="bg-indigo-600 py-2 w-full text-white font-serif font-semibold"
                  >
                    {loading ? (
                      <ClipLoader color="white" loading={loading} size={25} />
                    ) : (
                      "create my account"
                    )}
                  </button>
                </div>
              </form>
            </div>
            <div className="text-center">
              <p className="font-mono">
                Already Have an account ?{" "}
                <Link
                  to="/sign-in"
                  className="text-blue-500 hover:underline cursor-pointer"
                >
                  Sign in
                </Link>{" "}
              </p>
            </div>
          </div>
          <div className="hidden lg:inline-grid lg:place-items-end px-5 py-5">
            <img src="/images/Signup.svg" alt="" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SignUp;
